import React from 'react'
import '../../../css/Category/Bakery.scss'

function Bakery({active}) {
    return (
        <div className={active === true ? 'Bakery active' : 'Bakery'}>
            <div
                style={{
                    width: 60,
                    height: 60,
                    overflow: "hidden",
                    display: "block",
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 760 760"
                    width={760}
                    height={760}
                    preserveAspectRatio="xMidYMid meet"
                    style={{
                        width: "100%",
                        height: "100%",
                        transform: "translate3d(0px, 0px, 0px)"
                    }}
                >
                    <defs>
                        <clipPath id="__lottie_element_408">
                            <rect width={760} height={760} x={0} y={0} />
                        </clipPath>
                    </defs>
                    <g clipPath="url(#__lottie_element_408)">
                        <g
                            className='g-1'
                            transform="matrix(-0.008818035013973713,0.19980551302433014,-0.19980551302433014,-0.008818035013973713,446.68359375,327.6325378417969)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,189.6909942626953,-1.996000051498413)"
                            >
                                <path
                                    fill="rgb(209,240,246)"
                                    fillOpacity={1}
                                    d=" M118,-148 C-7.690999984741211,-264.0039978027344 -134.6909942626953,-283.0039978027344 -246,-210 C-324.9989929199219,-170.6909942626953 -367.6910095214844,-43.00400161743164 -315,67 C-288.96600341796875,121.35199737548828 -244.66700744628906,235.4669952392578 -98,299.0010070800781 C-65.69100189208984,312.9960021972656 121.30899810791016,368.9960021972656 239,272 C299.7409973144531,221.94000244140625 268.3080139160156,43.99599838256836 243,1 C219.08299255371094,-39.63199996948242 178.4759979248047,-92.18499755859375 118,-148z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-2'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity="0.9500000000000001"
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,402.49200439453125,423.42401123046875)"
                            >
                                <path
                                    fill="rgb(193,225,231)"
                                    fillOpacity={1}
                                    d=" M35.41299819946289,-184.98199462890625 C-4.769999980926514,-184.98199462890625 -47.56800079345703,-175.81900024414062 -88.98200225830078,-154.2310028076172 C-225.7010040283203,-82.96399688720703 -247.3459930419922,70.30899810791016 -223.89599609375,105.97100067138672 C-190.7550048828125,156.37100219726562 -77.76100158691406,184.98199462890625 -20.108999252319336,184.98199462890625 C-9.781999588012695,184.98199462890625 -1.2369999885559082,184.06500244140625 4.763000011444092,182.19000244140625 C91.87100219726562,154.968994140625 57.3849983215332,101.43699645996094 135.4250030517578,62.41699981689453 C211.6439971923828,24.30699920654297 251.69000244140625,25.145000457763672 222.5330047607422,-79.13400268554688 C206.50599670410156,-136.4530029296875 127.88400268554688,-184.98199462890625 35.41299819946289,-184.98199462890625z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-3'
                            form="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,436.47698974609375,299.3590087890625)"
                            >
                                <path
                                    fill="rgb(130,84,34)"
                                    fillOpacity={1}
                                    d=" M-95.46600341796875,-116.70700073242188 C-118.29499816894531,-104.4729995727539 -138.20399475097656,-64.88899993896484 -146.72000122070312,-49.24700164794922 C-155.23699951171875,-33.60599899291992 -148.01100158691406,21.573999404907227 -143.65199279785156,44.77399826049805 C-139.29299926757812,67.9739990234375 -149.9340057373047,67.38700103759766 -107.69100189208984,97.51100158691406 C-65.4489974975586,127.63500213623047 -8.678999900817871,142.6510009765625 4.304999828338623,140.9510040283203 C17.288000106811523,139.25100708007812 105.14199829101562,109.25700378417969 116,91.3280029296875 C126.85800170898438,73.39800262451172 150.75399780273438,49.138999938964844 152.9949951171875,15.831000328063965 C155.23599243164062,-17.47800064086914 148.05599975585938,-37.00699996948242 133.05599975585938,-60.79399871826172 C118.05500030517578,-84.58100128173828 101.6729965209961,-108.8479995727539 75.9219970703125,-123.96399688720703 C50.172000885009766,-139.08099365234375 21.97100067138672,-142.6510009765625 7.604000091552734,-141.42999267578125 C-12.020999908447266,-139.76199340820312 -43.42499923706055,-132.76600646972656 -56.88800048828125,-129.68299865722656 C-70.3499984741211,-126.5989990234375 -95.46600341796875,-116.70700073242188 -95.46600341796875,-116.70700073242188z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-4'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity="0.68"
                            style={{ mixBlendMode: "screen", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,432.0369873046875,281.80999755859375)"
                            >
                                <path
                                    fill="rgb(239,205,162)"
                                    fillOpacity={1}
                                    d=" M-144.38800048828125,32.46799850463867 C-144.38800048828125,32.46799850463867 -133.48199462890625,23.743999481201172 -106.56199645996094,14.315999984741211 C-79.64199829101562,4.888000011444092 -9.706000328063965,-24.01799964904785 -0.3330000042915344,-19.20800018310547 C9.039999961853027,-14.39900016784668 18.077999114990234,27.79800033569336 28.20800018310547,53.183998107910156 C37.54800033569336,76.58899688720703 54.902000427246094,121.80999755859375 59.125999450683594,123.27300262451172 C63.349998474121094,124.73600006103516 85.6449966430664,83.23699951171875 84.08899688720703,69.41300201416016 C75.5770034790039,-6.251999855041504 53.46500015258789,-33.391998291015625 53.46500015258789,-33.391998291015625 C53.46500015258789,-33.391998291015625 78.45099639892578,-37.23899841308594 97.76399993896484,-38.362998962402344 C109.64800262451172,-39.05400085449219 145.76300048828125,-35.80099868774414 145.76300048828125,-35.80099868774414 C145.76300048828125,-35.80099868774414 136.11599731445312,-62.58300018310547 108.87999725341797,-70.4540023803711 C87.36000061035156,-76.6729965209961 36.50299835205078,-84.58399963378906 36.50299835205078,-84.58399963378906 C36.50299835205078,-84.58399963378906 28.579999923706055,-93.5790023803711 15.508000373840332,-105.91999816894531 C2.436000108718872,-118.26100158691406 -7.861999988555908,-122.31999969482422 -17.759000778198242,-123.69200134277344 C-25.283000946044922,-124.73600006103516 -62.70600128173828,-118.79100036621094 -62.70600128173828,-118.79100036621094 C-62.70600128173828,-118.79100036621094 -26.226999282836914,-71.93299865722656 -26.226999282836914,-71.93299865722656 C-26.226999282836914,-71.93299865722656 -79.0989990234375,-55.867000579833984 -99.94499969482422,-41.209999084472656 C-118.79399871826172,-27.95800018310547 -134.197998046875,-1.50600004196167 -141.406005859375,14.74899959564209 C-145.76300048828125,24.57699966430664 -144.38800048828125,32.46799850463867 -144.38800048828125,32.46799850463867z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-5'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ mixBlendMode: "multiply", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,526.1320190429688,288.98699951171875)"
                            >
                                <path
                                    fill="rgb(246,225,200)"
                                    fillOpacity={1}
                                    d=" M-36.02299880981445,-34.470001220703125 C-36.02299880981445,-34.470001220703125 -19.187000274658203,-4.0920000076293945 -16.259000778198242,16.03700065612793 C-13.331000328063965,36.16699981689453 -11.866999626159668,40.92499923706055 -11.866999626159668,40.92499923706055 C-11.866999626159668,40.92499923706055 -9.305000305175781,18.5939998626709 -8.206999778747559,6.520999908447266 C-7.109000205993652,-5.556000232696533 -4.446000099182129,-17.90399932861328 11.1899995803833,-28.979999542236328 C19.974000930786133,-35.20199966430664 37.17599868774414,-40.69200134277344 37.17599868774414,-40.69200134277344 C37.17599868774414,-40.69200134277344 -2.3510000705718994,-41.790000915527344 -16.259000778198242,-39.22800064086914 C-30.16699981689453,-36.66600036621094 -40.78099822998047,-37.763999938964844 -36.02299880981445,-34.470001220703125z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-6'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ mixBlendMode: "multiply", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,409.2560119628906,325.29901123046875)"
                            >
                                <path
                                    fill="rgb(246,225,200)"
                                    fillOpacity={1}
                                    d=" M-26.749000549316406,-46.2599983215332 C-6.389999866485596,-53.95100021362305 13.87600040435791,-57.97200012207031 21.195999145507812,-53.58000183105469 C28.516000747680664,-49.1879997253418 36.933998107910156,-27.5939998626709 47.18199920654297,1.684999942779541 C57.43000030517578,30.96500015258789 63.2859992980957,50.729000091552734 62.55400085449219,55.12099838256836 C61.821998596191406,59.512001037597656 34.00600051879883,10.102999687194824 -4.789000034332275,-6.000999927520752 C-52.832000732421875,-25.94300079345703 -62.61600112915039,-28.691999435424805 -62.61600112915039,-28.691999435424805 C-62.61600112915039,-28.691999435424805 -59.68899917602539,-33.816001892089844 -26.749000549316406,-46.2599983215332z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-7'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,360.364990234375,208.6909942626953)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-0.8190000057220459,-2.257999897003174 C1.340999960899353,-2.1670000553131104 1.6030000448226929,-2.2950000762939453 2.1740000247955322,-0.7829999923706055 C2.746000051498413,0.7300000190734863 2.2049999237060547,2.2950000762939453 1.159000039100647,2.1519999504089355 C0.11299999803304672,2.009000062942505 -2.746000051498413,0.1420000046491623 -2.746000051498413,0.1420000046491623 C-2.746000051498413,0.1420000046491623 -0.8190000057220459,-2.257999897003174 -0.8190000057220459,-2.257999897003174z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-8'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,388.9330139160156,202.85699462890625)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-0.984000027179718,-1.2059999704360962 C-3.068000078201294,-1.152999997138977 -2.9260001182556152,-0.07100000232458115 -2.4030001163482666,1.4010000228881836 C-1.8799999952316284,2.872999906539917 3.068000078201294,2.005000114440918 2.8469998836517334,1.1540000438690186 C2.625,0.3019999861717224 2.7230000495910645,-1.4709999561309814 2.190999984741211,-2.171999931335449 C1.659000039100647,-2.872999906539917 -0.984000027179718,-1.2059999704360962 -0.984000027179718,-1.2059999704360962z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-9'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,381.37200927734375,191.91400146484375)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M0.37299999594688416,-2.505000114440918 C-1.0789999961853027,-2.315000057220459 -2.252000093460083,-2.38100004196167 -2.0299999713897705,-1.5299999713897705 C-1.809000015258789,-0.6790000200271606 -1.996000051498413,2.0969998836517334 -1.3040000200271606,2.3369998931884766 C-0.6119999885559082,2.5759999752044678 2.252000093460083,1.7610000371932983 2.252000093460083,1.7610000371932983 C2.252000093460083,1.7610000371932983 0.9139999747276306,-2.5759999752044678 0.37299999594688416,-2.505000114440918z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-10'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,401.3810119628906,202.781005859375)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-1.1610000133514404,-2.4619998931884766 C0.9049999713897705,-0.972000002861023 4.105000019073486,2.4619998931884766 1.027999997138977,1.6540000438690186 C-2.0490000247955322,0.847000002861023 -4.105000019073486,-1.4149999618530273 -4.105000019073486,-1.4149999618530273 C-4.105000019073486,-1.4149999618530273 -1.1610000133514404,-2.4619998931884766 -1.1610000133514404,-2.4619998931884766z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-11'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,462.5039978027344,179.7209930419922)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-2.8459999561309814,-0.40400001406669617 C-2.4739999771118164,0.7580000162124634 -1.0299999713897705,2.549999952316284 -0.17800000309944153,2.3289999961853027 C0.6729999780654907,2.1070001125335693 2.8459999561309814,1.0529999732971191 2.4739999771118164,-0.10899999737739563 C2.1019999980926514,-1.2710000276565552 0.7179999947547913,-1.75 -0.4339999854564667,-2.1500000953674316 C-1.5870000123977661,-2.5490000247955322 -2.8459999561309814,-0.40400001406669617 -2.8459999561309814,-0.40400001406669617z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-12'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,475.0379943847656,189.76800537109375)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-2.86899995803833,1.1299999952316284 C-2.2660000324249268,2.371999979019165 1.440999984741211,2.1059999465942383 1.440999984741211,2.1059999465942383 C1.440999984741211,2.1059999465942383 3.321000099182129,-0.3409999907016754 3.321000099182129,-0.3409999907016754 C3.321000099182129,-0.3409999907016754 1.184000015258789,-2.371999979019165 0.10199999809265137,-2.2300000190734863 C-0.9789999723434448,-2.0889999866485596 -3.321000099182129,0.19900000095367432 -2.86899995803833,1.1299999952316284z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-13'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,493.15899658203125,202.19500732421875)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M0.5059999823570251,-1.7869999408721924 C2.500999927520752,-0.8379999995231628 2.6519999504089355,-0.5270000100135803 2.4830000400543213,0.7049999833106995 C2.313999891281128,1.937999963760376 -0.9319999814033508,2.36299991607666 -1.7660000324249268,1.0410000085830688 C-2.5989999771118164,-0.2800000011920929 -2.6510000228881836,-2.36299991607666 -2.6510000228881836,-2.36299991607666 C-2.6510000228881836,-2.36299991607666 0.5059999823570251,-1.7869999408721924 0.5059999823570251,-1.7869999408721924z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-14'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,486.13800048828125,182.66200256347656)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-0.656000018119812,-1.871999979019165 C1.0470000505447388,-2.315000057220459 2.819999933242798,-2.2160000801086426 2.181999921798706,-0.3720000088214874 C1.5429999828338623,1.4730000495910645 0.9929999709129333,2.315000057220459 0.15000000596046448,1.7649999856948853 C-0.6919999718666077,1.215000033378601 -2.377000093460083,0.11400000005960464 -2.5980000495910645,-0.7369999885559082 C-2.819999933242798,-1.5889999866485596 -0.656000018119812,-1.871999979019165 -0.656000018119812,-1.871999979019165z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-15'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,399.2760009765625,274.0929870605469)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M1.2139999866485596,-1.715999960899353 C5.545000076293945,2.2249999046325684 1.8250000476837158,5.4670000076293945 1.8250000476837158,5.4670000076293945 C1.8250000476837158,5.4670000076293945 -5.544000148773193,2.1410000324249268 -5.544000148773193,2.1410000324249268 C-5.544000148773193,2.1410000324249268 -2.9089999198913574,-5.4679999351501465 1.2139999866485596,-1.715999960899353z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-16'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,434.0559997558594,285.82598876953125)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-0.9660000205039978,-2.6610000133514404 C1.5789999961853027,-2.553999900817871 1.8899999856948853,-2.7049999237060547 2.562999963760376,-0.921999990940094 C3.236999988555908,0.8600000143051147 2.5980000495910645,2.7049999237060547 1.3650000095367432,2.5360000133514404 C0.13300000131130219,2.367000102996826 -3.236999988555908,0.1679999977350235 -3.236999988555908,0.1679999977350235 C-3.236999988555908,0.1679999977350235 -0.9660000205039978,-2.6610000133514404 -0.9660000205039978,-2.6610000133514404z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-17'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,440.72601318359375,279.86199951171875)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M3.1449999809265137,0.7990000247955322 C1.2389999628067017,2.489000082015991 1.1200000047683716,2.812999963760376 -0.6019999980926514,1.9980000257492065 C-2.325000047683716,1.1829999685287476 -3.1449999809265137,-0.5879999995231628 -2.1410000324249268,-1.3229999542236328 C-1.1369999647140503,-2.056999921798706 2.815999984741211,-2.812999963760376 2.815999984741211,-2.812999963760376 C2.815999984741211,-2.812999963760376 3.1449999809265137,0.7990000247955322 3.1449999809265137,0.7990000247955322z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-18'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,419.08599853515625,299.3630065917969)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M0.22699999809265137,-2.8289999961853027 C-1.9279999732971191,-3.316999912261963 -2.7170000076293945,-1.7829999923706055 -3.0369999408721924,-0.8610000014305115 C-3.3559999465942383,0.061000000685453415 -2.1600000858306885,3.316999912261963 -0.9179999828338623,2.7139999866485596 C0.3240000009536743,2.111999988555908 2.256999969482422,1.746999979019165 2.806999921798706,0.9049999713897705 C3.3570001125335693,0.06300000101327896 0.22699999809265137,-2.8289999961853027 0.22699999809265137,-2.8289999961853027z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-19'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,422.56298828125,273.2120056152344)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M3.1579999923706055,-3.378999948501587 C0.8429999947547913,-3.4059998989105225 -1.5609999895095825,-2.430000066757202 -1.5609999895095825,-2.430000066757202 C-1.5609999895095825,-2.430000066757202 -3.1579999923706055,2.180999994277954 -1.3849999904632568,2.2790000438690186 C0.3889999985694885,2.377000093460083 2.615000009536743,3.4059998989105225 2.86299991607666,1.9429999589920044 C3.111999988555908,0.47999998927116394 3.1579999923706055,-3.378999948501587 3.1579999923706055,-3.378999948501587z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-20'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,511.8559875488281,255.66099548339844)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M0.39500001072883606,-1.5609999895095825 C2.630000114440918,-1.3029999732971191 4.545000076293945,-0.12300000339746475 3.2230000495910645,0.7110000252723694 C1.9019999504089355,1.5440000295639038 -0.8119999766349792,2.6689999103546143 -1.4149999618530273,1.4270000457763672 C-2.0179998874664307,0.1860000044107437 -4.545000076293945,-1.4630000591278076 -3.302999973297119,-2.065999984741211 C-2.061000108718872,-2.6689999103546143 0.39500001072883606,-1.5609999895095825 0.39500001072883606,-1.5609999895095825z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-21'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,500.4679870605469,258.9570007324219)"
                            >
                                <path
                                    fill="rgb(203,202,188)"
                                    fillOpacity={1}
                                    d=" M-0.7400000095367432,-2.997999906539917 C-1.6619999408721924,-3.316999912261963 -3.374000072479248,-2.1029999256134033 -3.2320001125335693,-1.0210000276565552 C-3.0910000801086426,0.061000000685453415 -1.8940000534057617,3.315999984741211 -0.34200000762939453,2.562000036239624 C1.2100000381469727,1.809000015258789 3.374000072479248,1.5260000228881836 2.5409998893737793,0.20399999618530273 C1.7070000171661377,-1.1169999837875366 -0.7400000095367432,-2.997999906539917 -0.7400000095367432,-2.997999906539917z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-22'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,294.3680114746094,438.3970031738281)"
                            >
                                <path
                                    fill="rgb(224,148,66)"
                                    fillOpacity={1}
                                    d=" M151.97000122070312,106.3740005493164 C168.91000366210938,94.27400207519531 178.4669952392578,-13.980999946594238 124.75399780273438,-52.683998107910156 C71.04100036621094,-91.38800048828125 17.075000762939453,-143.33099365234375 -46.31800079345703,-134.17300415039062 C-109.71199798583984,-125.01599884033203 -164.45199584960938,-78.94300079345703 -166.4929962158203,-47.11899948120117 C-168.53399658203125,-15.295999526977539 -178.46800231933594,19.326000213623047 -122.20800018310547,52.683998107910156 C-65.9489974975586,86.04199981689453 -14.529000282287598,143.3300018310547 40.97100067138672,136.9720001220703 C96.47200012207031,130.61500549316406 135.02999877929688,118.4739990234375 151.97000122070312,106.3740005493164z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-23'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ mixBlendMode: "multiply", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,277.5350036621094,419.6189880371094)"
                            >
                                <path
                                    fill="rgb(246,225,200)"
                                    fillOpacity={1}
                                    d=" M91.36299896240234,57.391998291015625 C101.04299926757812,63.44200134277344 26.023000717163086,102.16200256347656 -65.93800354003906,50.13199996948242 C-108.5469970703125,26.02400016784668 -86.50800323486328,-76.91899871826172 -86.50800323486328,-76.91899871826172 C-86.50800323486328,-76.91899871826172 -24.79800033569336,-15.208000183105469 17.55299949645996,16.25200080871582 C47.20600128173828,38.279998779296875 81.68299865722656,51.34199905395508 91.36299896240234,57.391998291015625z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-24'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity={1}
                            style={{ mixBlendMode: "multiply", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,310.8179931640625,388.32000732421875)"
                            >
                                <path
                                    fill="rgb(246,225,200)"
                                    fillOpacity={1}
                                    d=" M-64.12999725341797,-64.9800033569336 C-64.12999725341797,-64.9800033569336 6.050000190734863,-44.40999984741211 15.729999542236328,-27.469999313354492 C25.410999298095703,-10.529999732971191 64.13099670410156,65.70099639892578 64.13099670410156,65.70099639892578 C64.13099670410156,65.70099639892578 47.191001892089844,-17.790000915527344 35.090999603271484,-33.52000045776367 C22.990999221801758,-49.25 -62.91999816894531,-69.81999969482422 -64.12999725341797,-64.9800033569336z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-25'
                            transform="matrix(1,0,0,1,0,0)"
                            opacity="0.5"
                            style={{ mixBlendMode: "screen", display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,276.01300048828125,393.29400634765625)"
                            >
                                <path
                                    fill="rgb(224,201,129)"
                                    fillOpacity={1}
                                    d=" M101.75900268554688,82.91100311279297 C95.30599975585938,89.36399841308594 26.632999420166016,45.77799987792969 2.6549999713897705,26.56999969482422 C-21.322999954223633,7.361999988555908 -50.1510009765625,-20.621999740600586 -66.66200256347656,-40.137001037597656 C-83.1729965209961,-59.65299987792969 -102.10800170898438,-83.55599975585938 -102.10800170898438,-83.55599975585938 C-102.10800170898438,-83.55599975585938 -49.37799835205078,-74.50800323486328 -25.861000061035156,-66.5 C-2.3440001010894775,-58.49300003051758 27.545000076293945,-49.382999420166016 43.67900085449219,-38.09000015258789 C59.8120002746582,-26.79599952697754 106.5989990234375,76.45800018310547 101.75900268554688,82.91100311279297z"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <span className='title'>Bakery</span>
        </div>
    )
}

export default Bakery